import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule from "../Restaumatic.Menu.V2.Types.AvailabilitySchedule/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCombo from "../Restaumatic.Menu.V2.Types.Combo/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCrossSelling from "../Restaumatic.Menu.V2.Types.CrossSelling/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCustomParameter from "../Restaumatic.Menu.V2.Types.CustomParameter/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers from "../Restaumatic.Menu.V2.Types.EnabledMenuConsumers/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction from "../Restaumatic.Menu.V2.Types.Ids.UpdateAction/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenu from "../Restaumatic.Menu.V2.Types.Menu/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dMenuSection from "../Restaumatic.Menu.V2.Types.MenuSection/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dModifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dProduct from "../Restaumatic.Menu.V2.Types.Product/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dProductCategory from "../Restaumatic.Menu.V2.Types.ProductCategory/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const MenuCatalogueUpdate = x => x;
const MenuCatalogue = x => x;
const newtypeMenuCatalogue_ = {Coercible0: () => {}};
const newtypeMenuCatalogueUpdat = {Coercible0: () => {}};
const hasFieldMenuCatalogueUpda = dictHasField => dictHasField;
const hasFieldMenuCatalogue = dictHasField => dictHasField;
const eqMenuCatalogueUpdate = {
  eq: x => y => Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") {
          return Restaumatic$dCalendar$dTypes$dAvailability.eqWeeklyAvailability.eq(x$1._1.availability)(y$1._1.availability) && x$1._1.name === y$1._1.name;
        }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.availabilitySchedules)(y.availabilitySchedules) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dProductCategory.eqProductCategory.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.categories)(y.categories) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dCombo.eqCombo.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.combos)(y.combos) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dCrossSelling.eqCrossSellingList.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.crossSellingListsV2)(y.crossSellingListsV2) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dCustomParameter.eqCustomParameter.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.customParameters)(y.customParameters) && Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.eqEnabledMenuConsumers.eq(x.enabledMenuConsumers)(y.enabledMenuConsumers) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dMenu.eqMenu.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.menus)(y.menus) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dModifier.eqModifier.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.modifiers)(y.modifiers) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.eqPackagingContainer.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.packagingContainers)(y.packagingContainers) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dProduct.eqProduct.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.products)(y.products) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)({
    eq: x$1 => y$1 => {
      if (x$1.tag === "Delete") {
        if (y$1.tag === "Delete") { return true; }
        if (y$1.tag === "Update") { return false; }
        $runtime.fail();
      }
      if (x$1.tag === "Update") {
        if (y$1.tag === "Delete") { return false; }
        if (y$1.tag === "Update") { return Restaumatic$dMenu$dV2$dTypes$dMenuSection.eqMenuSection.eq(x$1._1)(y$1._1); }
        $runtime.fail();
      }
      if (y$1.tag === "Delete") { $runtime.fail(); }
      if (y$1.tag === "Update") { $runtime.fail(); }
      $runtime.fail();
    }
  }).eq(x.sections)(y.sections)
};
const eqMenuCatalogue = {
  eq: x => y => Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.eqAvailabilitySchedule).eq(x.availabilitySchedules)(y.availabilitySchedules) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dProductCategory.eqProductCategory).eq(x.categories)(y.categories) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dCombo.eqCombo).eq(x.combos)(y.combos) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.eqCrossSellingList).eq(x.crossSellingListsV2)(y.crossSellingListsV2) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dCustomParameter.eqCustomParameter).eq(x.customParameters)(y.customParameters) && Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.eqEnabledMenuConsumers.eq(x.enabledMenuConsumers)(y.enabledMenuConsumers) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dMenu.eqMenu).eq(x.menus)(y.menus) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dModifier.eqModifier).eq(x.modifiers)(y.modifiers) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.eqPackagingContainer).eq(x.packagingContainers)(y.packagingContainers) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dProduct.eqProduct).eq(x.products)(y.products) && Data$dMap$dInternal.eqMap(Data$dEq.eqString)(Restaumatic$dMenu$dV2$dTypes$dMenuSection.eqMenuSection).eq(x.sections)(y.sections)
};
const genericMenuCatalogueUpdate = {to: x => x, from: x => x};
const showMenuCatalogueUpdate = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dMenuSection.showMenuSection));
      const $1 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dProduct.showProduct));
      const $2 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showPackagingContainer));
      const $3 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dModifier.showModifier));
      const $4 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dMenu.showMenu));
      const $5 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dCustomParameter.showCustomParameter));
      const $6 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.showCrossSellingList));
      const $7 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dCombo.showCombo));
      const $8 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dProductCategory.showProductCategory));
      const $9 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.showUpdateAction(Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.showAvailabilitySchedule));
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["availabilitySchedules", $9.show(v.availabilitySchedules)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "categories",
              $8.show(v.categories)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["combos", $7.show(v.combos)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "crossSellingListsV2",
              $6.show(v.crossSellingListsV2)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["customParameters", $5.show(v.customParameters)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "enabledMenuConsumers",
              Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.showEnabledMenuConsumers.show(v.enabledMenuConsumers)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["menus", $4.show(v.menus)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["modifiers", $3.show(v.modifiers)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "packagingContainers",
              $2.show(v.packagingContainers)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["products", $1.show(v.products)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["sections", $0.show(v.sections)]))([])))))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "MenuCatalogueUpdate"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeMenuCatalogueUpdate = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "availabilitySchedules"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.unscrambleDecodeAvailabilitySchedule.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "categories"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dProductCategory.unscrambleDecodeProductCategory.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "combos"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCombo.unscrambleDecodeCombo.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "crossSellingListsV2"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCrossSelling.unscrambleDecodeCrossSellingList.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "customParameters"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dCustomParameter.unscrambleDecodeCustomParameter.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "enabledMenuConsumers"})(Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.unscrambleDecodeEnabledMenuConsumers)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "menus"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dMenu.unscrambleDecodeMenu.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "modifiers"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dModifier.unscrambleDecodeModifier.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "packagingContainers"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.unscrambleDecodePackagingContainer.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "products"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dProduct.unscrambleDecodeProduct.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordCons({reflectSymbol: () => "sections"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.udecodeUpdateAction({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dMenuSection.unscrambleDecodeMenuSection.unsafeDecode(x.contents)
    })))(Unscramble.decodeRecordNil))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericMenuCatalogue = {to: x => x, from: x => x};
const showMenuCatalogue = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dMenuSection.showMenuSection);
      const $1 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dProduct.showProduct);
      const $2 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showPackagingContainer);
      const $3 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dModifier.showModifier);
      const $4 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dMenu.showMenu);
      const $5 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dCustomParameter.showCustomParameter);
      const $6 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.showCrossSellingList);
      const $7 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dCombo.showCombo);
      const $8 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dProductCategory.showProductCategory);
      const $9 = Data$dMap$dInternal.showMap(Data$dUUID.showUUID)(Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.showAvailabilitySchedule);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["availabilitySchedules", $9.show(v.availabilitySchedules)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "categories",
              $8.show(v.categories)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["combos", $7.show(v.combos)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "crossSellingListsV2",
              $6.show(v.crossSellingListsV2)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["customParameters", $5.show(v.customParameters)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "enabledMenuConsumers",
              Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.showEnabledMenuConsumers.show(v.enabledMenuConsumers)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["menus", $4.show(v.menus)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["modifiers", $3.show(v.modifiers)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "packagingContainers",
              $2.show(v.packagingContainers)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["products", $1.show(v.products)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["sections", $0.show(v.sections)]))([])))))))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "MenuCatalogue"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeMenuCatalogue = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "availabilitySchedules"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.unscrambleDecodeAvailabilitySchedule))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "categories"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dProductCategory.unscrambleDecodeProductCategory))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "combos"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dCombo.unscrambleDecodeCombo))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "crossSellingListsV2"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.unscrambleDecodeCrossSellingList))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "customParameters"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dCustomParameter.unscrambleDecodeCustomParameter))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "enabledMenuConsumers"
    })(Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.unscrambleDecodeEnabledMenuConsumers)(Unscramble.decodeRecordCons({reflectSymbol: () => "menus"})(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dMenu.unscrambleDecodeMenu))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "modifiers"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dModifier.unscrambleDecodeModifier))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "packagingContainers"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.unscrambleDecodePackagingContainer))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "products"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dProduct.unscrambleDecodeProduct))(Unscramble.decodeRecordCons({
      reflectSymbol: () => "sections"
    })(Unscramble.decodeMap(Data$dUUID.ufromJSONKeyUUID)(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dMenuSection.unscrambleDecodeMenuSection))(Unscramble.decodeRecordNil))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeMenuCatalogueUpdate = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericMenuCatalogueUpdate)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "MenuCatalogueUpdate"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "sections"
    })((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dMenuSection.encodeMenuSection.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dMenuSection.encodeMenuSection.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "products"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dProduct.encodeProduct.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dProduct.encodeProduct.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "packagingContainers"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodePackagingContainer.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodePackagingContainer.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "modifiers"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dModifier.encodeModifier.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dModifier.encodeModifier.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "menus"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dMenu.encodeMenu.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dMenu.encodeMenu.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "enabledMenuConsumers"})({encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.encodeEnabledMenuConsumers.encode}))({
      reflectSymbol: () => "customParameters"
    })((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCustomParameter.encodeCustomParameter.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCustomParameter.encodeCustomParameter.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "crossSellingListsV2"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCrossSelling.encodeCrossSellingList.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCrossSelling.encodeCrossSellingList.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "combos"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCombo.encodeCombo.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCombo.encodeCombo.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "categories"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dProductCategory.encodeProductCategory.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dProductCategory.encodeProductCategory.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "availabilitySchedules"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.encodeAvailabilitySchedule.encode(v)),
          Data$dList$dTypes.Nil
        )
      }))((() => {
        const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.encodeUpdateAction({
          encodeArgs: opts => v => Data$dList$dTypes.$List(
            "Cons",
            Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.encodeAvailabilitySchedule.encode(v)),
            Data$dList$dTypes.Nil
          )
        });
        return {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", $0.encode(v)), Data$dList$dTypes.Nil)};
      })());
      return {encodeWithOptions: v => $0.encode};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeMenuCatalogue = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericMenuCatalogue)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "MenuCatalogue"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "sections"
    })((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dMenuSection.encodeMenuSection)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dMenuSection.encodeMenuSection.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "products"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dProduct.encodeProduct)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dProduct.encodeProduct.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "packagingContainers"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodePackagingContainer)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodePackagingContainer.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "modifiers"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dModifier.encodeModifier)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dModifier.encodeModifier.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "menus"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dMenu.encodeMenu)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dMenu.encodeMenu.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "enabledMenuConsumers"})({encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.encodeEnabledMenuConsumers.encode}))({
      reflectSymbol: () => "customParameters"
    })((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dCustomParameter.encodeCustomParameter)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCustomParameter.encodeCustomParameter.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "crossSellingListsV2"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.encodeCrossSellingList)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCrossSelling.encodeCrossSellingList.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "combos"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dCombo.encodeCombo)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dCombo.encodeCombo.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "categories"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dProductCategory.encodeProductCategory)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dProductCategory.encodeProductCategory.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })()))({reflectSymbol: () => "availabilitySchedules"})((() => {
      const $0 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.encodeAvailabilitySchedule)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.encodeAvailabilitySchedule.encode(v)),
          Data$dList$dTypes.Nil
        )
      });
      return {encodeWithOptions: v => $0.encode};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeMenuCatalogueUpdate = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericMenuCatalogueUpdate)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "MenuCatalogueUpdate"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "sections"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dMenuSection.decodeMenuSection.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dMenuSection.decodeMenuSection.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "products"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dProduct.decodeProduct.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dProduct.decodeProduct.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "packagingContainers"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodePackagingContainer.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodePackagingContainer.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "modifiers"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dModifier.decodeModifier.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dModifier.decodeModifier.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "menus"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dMenu.decodeMenu.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dMenu.decodeMenu.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "enabledMenuConsumers"})({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.decodeEnabledMenuConsumers.decode})())({
    reflectSymbol: () => "customParameters"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCustomParameter.decodeCustomParameter.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCustomParameter.decodeCustomParameter.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "crossSellingListsV2"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCrossSelling.decodeCrossSellingList.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCrossSelling.decodeCrossSellingList.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "combos"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCombo.decodeCombo.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCombo.decodeCombo.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "categories"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dProductCategory.decodeProductCategory.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dProductCategory.decodeProductCategory.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "availabilitySchedules"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.decodeAvailabilitySchedule.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }))((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dIds$dUpdateAction.decodeUpdateAction({
        decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.decodeAvailabilitySchedule.decode}),
        decodeSingleRecordArg: Data$dMaybe.Nothing
      });
      return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
    })());
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeMenuCatalogue = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericMenuCatalogue)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "MenuCatalogue"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "sections"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dMenuSection.decodeMenuSection)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dMenuSection.decodeMenuSection.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "products"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dProduct.decodeProduct)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dProduct.decodeProduct.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "packagingContainers"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodePackagingContainer)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodePackagingContainer.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "modifiers"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dModifier.decodeModifier)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dModifier.decodeModifier.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "menus"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dMenu.decodeMenu)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dMenu.decodeMenu.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "enabledMenuConsumers"})({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dEnabledMenuConsumers.decodeEnabledMenuConsumers.decode})())({
    reflectSymbol: () => "customParameters"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dCustomParameter.decodeCustomParameter)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCustomParameter.decodeCustomParameter.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "crossSellingListsV2"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.decodeCrossSellingList)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCrossSelling.decodeCrossSellingList.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "combos"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dCombo.decodeCombo)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dCombo.decodeCombo.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "categories"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dProductCategory.decodeProductCategory)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dProductCategory.decodeProductCategory.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "availabilitySchedules"})(/* #__PURE__ */ (() => {
    const $0 = Data$dMap$dSerialized.decodeMap(Data$dOrd.ordString)(Restaumatic$dMenu$dV2$dTypes$dIds$dEntityId.asJSONKeyEntityId)(Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.decodeAvailabilitySchedule)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailabilitySchedule.decodeAvailabilitySchedule.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    });
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  MenuCatalogue,
  MenuCatalogueUpdate,
  decodeMenuCatalogue,
  decodeMenuCatalogueUpdate,
  encodeMenuCatalogue,
  encodeMenuCatalogueUpdate,
  eqMenuCatalogue,
  eqMenuCatalogueUpdate,
  genericMenuCatalogue,
  genericMenuCatalogueUpdate,
  hasFieldMenuCatalogue,
  hasFieldMenuCatalogueUpda,
  newtypeMenuCatalogueUpdat,
  newtypeMenuCatalogue_,
  showMenuCatalogue,
  showMenuCatalogueUpdate,
  unscrambleDecodeMenuCatalogue,
  unscrambleDecodeMenuCatalogueUpdate
};
